import React, { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import projects from "../data/projects.json";

const DropContext = React.createContext();

export function useDrop() {
  return useContext(DropContext);
}

export function DropProvider({ children }) {
  const [selection, setSelection] = useState(null);
  const location = useLocation();
  const parameters = new URLSearchParams(location.search);
  const candidate = parameters.has("project") ? parameters.get("project") : selection;
  const currentDrop = candidate && projects.some(project => project.firebaseProject === candidate)
    ? candidate : null;

  function setOption(option) {
    setSelection(option);
    return option;
  }

  return (
    <DropContext.Provider value={{ currentDrop, setOption }}>
      {children}
    </DropContext.Provider>
  );
}

